import React, { useState } from 'react';
import { Box, Flex, Text } from 'rebass'; // Assuming you're using theme-ui for styling
import { IoMdClose, IoMdCheckmark } from 'react-icons/io';
import apiBase, { baseUrl } from 'utils/api-base';
import { getRequestOptions } from 'utils/api';
import { FiGift } from "react-icons/fi";
import { label } from './SignUp';
import { TextInput } from 'app/payment/DesignGiftCertificate';

const GiftCertificateField = ({
    // showGiftcard,
    // setShowGiftcard,
    status,
    setStatus,
    setRedeemCode
}) => {
    const [showGiftcard, setShowGiftcard] = useState(null);

    const handleChange = (e) => {
        let rawValue = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
        let maskedValue = '';

        if (rawValue.length > 0) {
            maskedValue += rawValue.slice(0, 4);
        }
        if (rawValue.length > 4) {
            maskedValue += '-' + rawValue.slice(4, 8);
        }
        if (rawValue.length > 8) {
            maskedValue += '-' + rawValue.slice(8, 12);
        }
        e.target.value = maskedValue.toUpperCase()

        if (e.target.value.length === 14)
            getCouponDetails(e.target.value)

        setRedeemCode(e.target.value)
    };

    async function getCouponDetails(code = null) {
        const resp = await fetch(`${baseUrl}/v3/commerce/gift_certificates/${code}`, getRequestOptions())
        const response = await resp.json();

        if (response?.data === null || response?.errors?.length > 0) {
            setStatus({ type: 'error', message: 'Your gift certificate has been used or is unrecognized', subTitle: <>Please double check your code and try again. If you're still experiencing problems, please <Text as="a" href="mailto:hello@babyyearbooks.com" target="_blank" sx={{ textDecorationLine: 'underline', cursor: 'pointer', fontWeight: 500 }} color="inherit">contact us</Text></> })
            return false
        }
        setStatus({ type: 'success', message: "Gift card applied successfully", subTitle: "You're all set to preserve and celebrate your little one's firsts" })
        return true
    }

    return (<>
        {showGiftcard ? (
            <Flex sx={{ position: 'relative' }}>
                <Box
                    as={IoMdClose}
                    onClick={() => {
                        // setFieldValue('gift-certificate', '');
                        setStatus({ type: '', message: '' });
                        setShowGiftcard(!showGiftcard);
                    }}
                    color="#fff"
                    size={24}
                    bg="#000"
                    sx={{
                        cursor: 'pointer',
                        borderRadius: '50%',
                        p: '4px',
                        position: 'absolute',
                        right: 0
                    }}
                />
                <TextInput
                    name="gift-certificate"
                    placeholder="Enter gift certificate"
                    width="100%"
                    title={label('Gift Certificate')}
                    onBlur={(e) => !!e.target.value && getCouponDetails(e.target.value)}
                    onChange={handleChange}
                    mt={0}
                />
            </Flex>
        ) : (
            <Flex
                maxWidth="max-content"
                justifyContent="center"
                alignItems="center"
                onClick={() => setShowGiftcard(true)}
                sx={{ cursor: 'pointer' }}
                m="auto"
            >
                <Box
                    as={FiGift}
                    color="#9B59B6"
                    size={24}
                    mr={1}
                />
                <Text fontSize="16px" fontWeight={500} lineHeight="150%" color="#9B59B6">
                    Redeem a gift certificate
                </Text>
            </Flex>
        )}
        {status?.type === 'error' && (
            <Box mt={2} p={2} sx={{ borderRadius: '8px', backgroundColor: '#FDEDEC', border: '1px solid #F5C6CB' }}>
                <Flex alignItems="center">
                    <Text fontSize="14px" color="#721C24" fontWeight={500} lineHeight="150%">{status?.message}</Text>
                </Flex>
                {status?.subTitle && <Text mt={1} fontSize="14px" color="#721C24" lineHeight="150%">{status?.subTitle}</Text>}          </Box>
        )}
    </>
    )
};

export default GiftCertificateField;
